// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-V-u","content":"styles_content__NC283"};